import React from 'react';

import type { PluginContainerData_Width_Type } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { RicosServices, ToolbarButton } from './../ricos-types';
import {
  decorateComponentWithProps,
  PLUGIN_TOOLBAR_BUTTON_ID,
} from './../editor-common';
import { getVisibleOnlyOnDesktopResolver } from './../plugin-commons';
import { handleFileUpload } from './/handle-file-upload';
import {
  AlignmentPanel,
  NodeAlignmentButton,
  NodeSizeButton,
  SizePanel,
} from './../toolbars-ui';

import { FILE_BUTTONS } from './consts';

export const getToolbarButtons = (
  config: Record<string, any>,
  services: RicosServices
): ToolbarButton[] => {
  const {
    context: { isMobile },
  } = services;

  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: ['SMALL', 'CONTENT'] as PluginContainerData_Width_Type[],
        }),
        id: FILE_BUTTONS.size,
      },
      renderer: toolbarItem => <NodeSizeButton id={FILE_BUTTONS.size} toolbarItem={toolbarItem} />,
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile),
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: FILE_BUTTONS.alignment,
      },
      renderer: toolbarItem => (
        <NodeAlignmentButton toolbarItem={toolbarItem} id={FILE_BUTTONS.alignment} />
      ),
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile),
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      tooltip: 'FileUploadReplaceButton_tooltip',
      command: ({ attributes: { selectedNode }, publicCommands }) => {
        handleFileUpload({ config, services, publicCommands, nodeId: selectedNode.attrs.id });
      },
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
    },
  ];
};
